import { useLayoutEffect } from "react";
import { Outlet } from "react-router-dom";

export default function CNLayout() {
  useLayoutEffect(() => {
    const prev = document.documentElement.lang;
    document.documentElement.lang = "zh-CN";
    return () => {
      document.documentElement.lang = prev || "ko-KR";
    };
  }, []);

  return <Outlet />;
}
